import { __assign } from "tslib";
import update from 'immutability-helper';
import * as actionTypes from '../constants/actionTypes';
import * as requestStatus from '../constants/requestStatus';
export var initialState = {
    code: {},
    requestStatus: {},
    currentLang: null,
};
export default function codeReducer(state, action) {
    var _a, _b, _c, _d, _e;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.SHOW_SCREEN:
            return __assign(__assign({}, initialState), { currentLang: state.currentLang });
        case actionTypes.LOAD_CODE_START:
            return update(state, {
                requestStatus: { $merge: (_a = {}, _a[action.lang] = requestStatus.PENDING, _a) },
            });
        case actionTypes.LOAD_CODE_DONE:
            return update(state, {
                code: { $merge: (_b = {}, _b[action.lang] = action.code, _b) },
                requestStatus: { $merge: (_c = {}, _c[action.lang] = requestStatus.SUCCESS, _c) },
            });
        case actionTypes.LOAD_CODE_FAILED:
            return update(state, {
                code: { $merge: (_d = {}, _d[action.lang] = action.err, _d) },
                requestStatus: { $merge: (_e = {}, _e[action.lang] = requestStatus.ERROR, _e) },
            });
        case actionTypes.SET_DEFAULT_PROJECT_LANG:
        case actionTypes.SET_CURRENT_LANG:
            return update(state, {
                currentLang: { $set: action.lang },
            });
        default:
            return state;
    }
}
